module.exports = __webpack_public_path__ + "static/img_9522-b66199693967c78a7e6ac00e329812b0.webp";